import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select"]
  static values  = { url: String }

  connect() {
    this.dropdownEl = null
    Object.assign(this.selectTarget.style, { position: "absolute", opacity: "0", height: "0", width: "0", overflow: "hidden", pointerEvents: "none" })
    this.bound = this.#clickOutside.bind(this)
    document.addEventListener("click", this.bound)
  }

  disconnect() {
    document.removeEventListener("click", this.bound)
    this.dropdownEl?.remove()
  }

  async search() {
    const q = this.inputTarget.value.trim()
    const url = q.length >= 1
      ? `${this.urlValue}${this.urlValue.includes("?") ? "&" : "?"}q=${encodeURIComponent(q)}`
      : this.urlValue

    if (q.length === 0 && !this.urlValue) { this.#hide(); return }

    const resp = await fetch(url)
    const data = await resp.json()

    this.#hide()
    if (!data.length) return

    this.#showDropdown(data)
  }

  #showDropdown(data) {
    const rect = this.inputTarget.getBoundingClientRect()
    const dropdown = document.createElement("div")
    dropdown.className = "fixed z-[9999] bg-surface-1 border border-border-subtle rounded-lg shadow-lg max-h-64 overflow-y-auto"
    dropdown.style.top  = `${rect.bottom + window.scrollY}px`
    dropdown.style.left = `${rect.left}px`
    dropdown.style.width = `${rect.width}px`

    data.forEach(item => {
      const el = document.createElement("div")
      el.className = "px-3 py-2 text-sm cursor-pointer hover:bg-surface-2 transition-colors"
      el.dataset.id = item.id
      el.textContent = item.name
      // Ligne secondaire optionnelle (ex. ville et SIRET d'un compte)
      if (item.hint) {
        const hint = document.createElement("div")
        hint.className = "text-xs text-text-muted truncate"
        hint.textContent = item.hint
        el.appendChild(hint)
      }
      el.addEventListener("click", () => this.#pick(String(item.id), item.name))
      dropdown.appendChild(el)
    })

    document.body.appendChild(dropdown)
    this.dropdownEl = dropdown
  }

  #pick(id, name) {
    this.inputTarget.value = name
    this.inputTarget.classList.remove("border-red-500", "field-invalid")
    let opt = this.selectTarget.querySelector(`option[value="${id}"]`)
    if (!opt) {
      opt = new Option(name, id)
      this.selectTarget.add(opt)
    }
    this.selectTarget.value = id
    this.#hide()
    this.dispatch("selected", { detail: { id, name } })
  }

  #hide() {
    this.dropdownEl?.remove()
    this.dropdownEl = null
  }

  #clickOutside(event) {
    if (!this.element.contains(event.target) && !this.dropdownEl?.contains(event.target)) {
      this.#hide()
    }
  }
}
